import { Helmet } from 'react-helmet';

import { env } from 'services/runtimeEnv';

const GOOGLE_ANALYTICS_ID = 'UA-213796548-1';

const ReactHelmet = () => {
  // Must be read inside the component: at module scope a bundle baked with
  // ENVIRONMENT=development gets the GA JSX dead-code-eliminated by terser,
  // and no runtime override could ever re-enable it (ACT-16862).
  const isProduction = env('ENVIRONMENT') === 'production';

  return (
    <Helmet>
      {isProduction ? (
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`}></script>
      ) : null}
      {isProduction ? (
        <script>
          {`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments)}gtag('js', new Date()); gtag('config', '${GOOGLE_ANALYTICS_ID}')`}
        </script>
      ) : null}
    </Helmet>
  );
};

export default ReactHelmet;
